import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from '@mui/material';

const OtpInitiationStep = ({
  classes,
  otpDeliveryMethod,
  setOtpDeliveryMethod,
  phone,
  stepStatus,
  onBack,
  onSend,
}) => {
  const disabled = stepStatus['phone-possession'] === 'completed';

  return (
    <Box className={classes.stepContent}>
      <FormControl component="fieldset" disabled={disabled}>
        <FormLabel component="legend">Select OTP Delivery Method</FormLabel>
        <RadioGroup
          row
          value={otpDeliveryMethod}
          onChange={(e) => setOtpDeliveryMethod(e.target.value)}
        >
          <FormControlLabel value="sms" control={<Radio />} label="SMS" />
          <FormControlLabel value="voice" control={<Radio />} label="Voice Call" />
        </RadioGroup>
      </FormControl>
      <Typography variant="body1" style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
        OTP will be sent via {otpDeliveryMethod === 'sms' ? 'SMS' : 'Voice Call'} to {phone}
      </Typography>
      <Box className={classes.buttonContainer}>
        <Button
          variant="outlined"
          onClick={onBack}
          disabled={disabled}
        >
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSend}
          disabled={disabled}
        >
          Send OTP
        </Button>
      </Box>
    </Box>
  );
};

export default OtpInitiationStep;